import { getAuth } from "firebase/auth";

const API_BASE = (import.meta?.env?.VITE_API_BASE || "").replace(/\/$/, "");

function apiUrl(path) {
  return `${API_BASE}${path}`;
}

async function getAuthToken() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) return null;
  return user.getIdToken();
}

export async function apiEnviarPropostaEmail({ grupoId, tipo, to, subject, fileName, pdfBase64, context }) {
  const token = await getAuthToken();
  if (!token) throw new Error("Usuário não autenticado");

  const res = await fetch(apiUrl("/api/propostas/email/send"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      grupoId,
      tipo,
      to,
      subject,
      fileName,
      pdfBase64,
      context: context || {},
    }),
  });

  const raw = await res.text();
  let data = null;
  try {
    data = JSON.parse(raw);
  } catch {
    data = null;
  }

  if (!res.ok || !data?.ok) {
    throw new Error(data?.error || "Falha ao enviar proposta por e-mail");
  }

  return data;
}
